import AppContainer from "./components/appContainer/AppContainer";
import { Provider } from "react-redux";
import store from "./store/store";
import AppNavigator from "./navigation/AppNavigator";
import ThemeProvider from "./providers/ThemeProvider";

///

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <AppContainer>
          <AppNavigator />
        </AppContainer>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
